import { Col, Container, Nav, NavLink, Row, Stack } from "react-bootstrap";
import { Link } from "react-router-dom";
import logoAbaBlanco from '../../assets/aba/logo-aba-blanco.png'
import instagram from '../../assets/logos/instagram.png'
import facebook from '../../assets/logos/facebook.png'
import { useTranslation } from 'react-i18next'

const block1 = {
    alignItems: 'center'
};

const block2 = {
    backgroundColor: 'red',
};

const block3 = {
    backgroundColor: 'yellow',
};

const block4 = {
    backgroundColor: 'green',
};

const mainContainer = {
    textAlign: 'center',
    alignItems: 'center'
}

function Footer() {

    const { i18n, t } = useTranslation();

    return (
        <footer>
            <Container fluid style={mainContainer}>
                <Row className="bg-black text-white p-4">
                    <Col xs={12} md={3}>
                        <Stack style={block1}>
                        <img
                            src={logoAbaBlanco}
                            width="100"
                            height="100"
                            alt="Aba logo"
                        />
                        {/* <p>Lema Empresa</p> */}
                        </Stack>
                    </Col>
                    <Col xs={12} md={3}>
                        <Nav className="flex-column fs-5">
                            <NavLink href="/" className="text-white">{t('footerInit')}</NavLink>
                            <NavLink href="/history" className="text-white">{t('footerInstitutional')}</NavLink>
                            <NavLink href="/productFamily" className="text-white">{t('footerOurBrands')}</NavLink>
                        </Nav>
                    </Col>
                    <Col xs={12} md={3}>
                        <h4>{t('contact')}</h4>
                        <p>ababebidas@gmail.com</p>
                        <p>Tel: +5491121558484</p>
                    </Col>
                    <Col xs={12} md={3}>
                        <h4>{t('socialNetworking')}</h4>
                        <Row>
                            <Col md={6} xs={4} style={{height: '30px', width:'60px', marginTop: '40px'}}>
                                <Link to='https://www.instagram.com/aba_bebidas/'>
                                    <img
                                            src={instagram}
                                            width="100%"
                                            height="100%"
                                            className="d-inline-block align-top"
                                            alt="Aba logo"
                                    />
                                </Link>
                            </Col>
                            <Col md={6} xs={4} style={{height: '25px', width:'55px', marginTop: '40px'}}>
                                <Link to='https://www.facebook.com/profile.php?id=100069679920591&locale=es_LA'>
                                    <img
                                            src={facebook}
                                            width="100%"
                                            height="100%"
                                            className="d-inline-block align-top"
                                            alt="Aba logo"
                                    />
                                </Link>
                            </Col>
                        </Row>

                    </Col>
                </Row>
            </Container>
        </footer>
    )
}

export default Footer;